module.exports = __webpack_public_path__ + "static/breyer-labs-7fcc77b9f06390bd5eb8e72fe762788c.png";